import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["certificates", "fileMessage", "fileList"]
  static values = {
    tooManyFiles: String,
    fileListLabel: String,
    fileListEmpty: String,
    removeFile: String
  }

  connect() {
    this.selectedFiles = []
    this.renderFileList()
  }

  addFiles() {
    if (!this.hasCertificatesTarget) return

    const incomingFiles = Array.from(this.certificatesTarget.files)
    let rejectedForLimit = false

    incomingFiles.forEach((file) => {
      if (this.selectedFiles.some((selectedFile) => this.sameFile(selectedFile, file))) return

      if (this.selectedFiles.length >= 2) {
        rejectedForLimit = true
        return
      }

      this.selectedFiles.push(file)
    })

    this.syncInputFiles()
    this.renderFileList(rejectedForLimit ? this.tooManyFilesValue : null, rejectedForLimit)
  }

  removeFile(event) {
    const index = Number.parseInt(event.currentTarget.dataset.fileIndex, 10)
    if (Number.isNaN(index)) return

    this.selectedFiles.splice(index, 1)
    this.syncInputFiles()
    this.renderFileList()
  }

  sameFile(firstFile, secondFile) {
    return firstFile.name === secondFile.name &&
      firstFile.size === secondFile.size &&
      firstFile.lastModified === secondFile.lastModified
  }

  syncInputFiles() {
    if (!this.hasCertificatesTarget) return

    const transfer = new DataTransfer()
    this.selectedFiles.forEach((file) => transfer.items.add(file))
    this.certificatesTarget.files = transfer.files
  }

  renderFileList(message = null, error = false) {
    this.updateFileMessage(message, error)
    this.updateFileList()
  }

  updateFileMessage(message = null, error = false) {
    if (!this.hasFileMessageTarget) return

    const text = message || (this.selectedFiles.length > 0
      ? `${this.fileListLabelValue}: ${this.selectedFiles.length}/2`
      : this.fileListEmptyValue)

    this.fileMessageTarget.textContent = text
    this.fileMessageTarget.classList.toggle("is-error", error)
  }

  updateFileList() {
    if (!this.hasFileListTarget) return

    this.fileListTarget.replaceChildren()

    this.selectedFiles.forEach((file, index) => {
      const item = document.createElement("li")
      item.className = "selected-file-item"

      const name = document.createElement("span")
      name.className = "selected-file-name"
      name.textContent = file.name

      const removeButton = document.createElement("button")
      removeButton.type = "button"
      removeButton.className = "selected-file-remove"
      removeButton.dataset.fileIndex = index.toString()
      removeButton.textContent = this.removeFileValue
      removeButton.addEventListener("click", (event) => this.removeFile(event))

      item.append(name, removeButton)
      this.fileListTarget.append(item)
    })
  }
}
